
const languages = [
    { 
    	label: 'English', 
    	value: 0 
    },
    { 
    	label: 'Spanish', 
    	value: 1 
    },
    { 
        label: 'Creole', 
        value: 2
    }
]

const languageSearch = [
    {
        value: '-1',
        label: 'All',
    },
    {
        value: '0',
        label: 'English',
    },
    {
        value: '1',
        label: 'Spanish',
    }
];

const types = [
    {
        value: '-1',
        label: 'All',
    },
    {
        value: '0',
        label: 'Private',
    },
    {
        value: '1',
        label: 'Public',
    }
];

const trainingCost = 15;
const onlineTraining = 'Online';
const dvdTraining = 'DVD';
const zoomTraining = 'Zoom';
const zoomOnlyCourseId = 'Z000001'; // TODO make sure this course id exisi in the database before launch
const englishCourseId = '3959206'; 
const spanishCourseId = '16769245'; 

const trainingLanguageCourse = [
    { 
        label: 'English', 
        value: englishCourseId 
    },
    { 
        label: 'Spanish', 
        value: spanishCourseId 
    },
    {
        label: 'Zoom Class Record', 
        value: zoomOnlyCourseId 
    }
];


export { languages, languageSearch, types, trainingCost, trainingLanguageCourse,onlineTraining,dvdTraining,zoomTraining,zoomOnlyCourseId,englishCourseId,spanishCourseId }
